import { Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { Link, LinkProps } from "react-router-dom";

type EntaLinkProps = LinkProps;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    "&:visited": {
      color: "#0000EE",
    },
  },
}));

const EntaLink: React.FC<EntaLinkProps> = ({ children, ...rest }) => {
  const classes = useStyles();
  return (
    <Link {...rest} className={classes.root}>
      {children}
    </Link>
  );
};

export default EntaLink;
